import parse from 'html-react-parser'
import React, { FC } from 'react'

import { locale } from '../../locales/locale'
import { EditorSectionLink, SectionLink, SideBar, SideBarTitle } from '../common.components'
import { FixedSidebarItem, SidebarType } from '../definitions'

interface Props {
  editorModeActive: boolean
  fixedSidebar: FixedSidebarItem
  isExternal: boolean
  sideBar: SidebarType
  isArticle: boolean
  currentSection: number
}

const ArticleSidebar: FC<Props> = (props: Props) => {
  const {  currentSection, editorModeActive, fixedSidebar, isArticle, sideBar } = props
  return (
    <>
      {!isArticle && <></>}
      {isArticle && sideBar && (
        <SideBar
          editorModeActive={editorModeActive}
          fixedSideBar={fixedSidebar.fixedSideBar}
          fixedSideBarMaxBottom={fixedSidebar.fixedSideBarMaxBottom}
          isExternal={props.isExternal}
        >
          <>
            <SideBarTitle>{locale('In questa guida')}</SideBarTitle>
            {sideBar.map((link, idx) => {
              if(!editorModeActive) {
                return (
                    <SectionLink
                        key={idx}
                        to={link.id}
                        smooth
                        offset={0}
                        containerId={'articleContainer'}
                        className={currentSection === idx ? 'fr-view active' : 'fr-view'}
                        isActive={currentSection > idx ? true : undefined}
                    >
                      {parse(link.title)}
                    </SectionLink>
                )
              }
              else
              {
                return (
                    <>
                      <EditorSectionLink
                          key={idx}
                          title={link.title}
                          to={link.title}
                      />
                    </>
                )
              }

            })}
          </>
        </SideBar>
      )}
    </>
  )
}

export default ArticleSidebar
